export default __webpack_public_path__ + "static/media/offline.eed33b24.svg";